import * as FileSaver from "file-saver";
import React from "react";
import * as XLSX from "xlsx";
import Button from "../../../components/UI/Button/Button";
import DatePicker from "../../../components/UI/DatePicker/DatePicker";
import Input from "../../../components/UI/Input/Input";
import Modal from "../../../components/UI/Modal/Modal";
import Search from "../../../components/UI/Search/Search";
import Select from "../../../components/UI/Select/Select";
import Table from "../../../components/UI/Table/Table";
import FetchData from "../../../shared/fetchData";
import { updateObject } from "../../../shared/utility";
import ShowRentOrders from "../operations/ShowRentOrder";
import "./Rents.css";

const Rents = (props) => {
  const [from, setFrom] = React.useState("");
  const [to, setTo] = React.useState("");
  const [rents, setRents] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [tableData, setTableData] = React.useState([]);
  const [pageCount, setPageCount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [rerender, setRerender] = React.useState(false);
  const [searchParams, setSearchParams] = React.useState({
    rentNumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شماره سفارش",
      },
      validation: {
        required: true,
      },
      errorMessage: "",
      valid: true,
      value: "",
    },
  });
  const [modalContent, setModalContent] = React.useState("");
  const [kiosks, setKiosks] = React.useState([]);
  const [kiosk, setKiosk] = React.useState("");
  const [units, setUnits] = React.useState([]);
  const [unit, setUnit] = React.useState("");
  const [users, setUsers] = React.useState([]);
  const [user, setUser] = React.useState("");
  const childRef = React.useRef();

  React.useEffect(() => {
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
    const search = searchParams;
    for (let key in search) {
      search[key].value = "";
    }
    setSearchParams(search);
    const fromDate = new URLSearchParams(window.location.search).get("from");
    const toDate = new URLSearchParams(window.location.search).get("to");
    setFrom(fromDate);
    setTo(toDate);

    var raw = JSON.stringify({
      kiosk: {},
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });

    var url = "management/api/v1/kiosks/getKiosks";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setKiosks(result.kiosks);
        }
      })
      .catch((error) => console.log(error));
    var raw = JSON.stringify({
      unit: {},
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });

    var url = "management/api/v1/units/getUnits";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setUnits(result.units);
        }
      })
      .catch((error) => console.log(error));

    loadUsersForUnit(null);
  }, []);

  const loadUsersForUnit = (unitOption) => {
    const userFilter =
      unitOption != null && unitOption !== ""
        ? { username: "", unitId: unitOption.value }
        : { username: "" };
    var rawUsers = JSON.stringify({
      user: userFilter,
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    FetchData(rawUsers, "management/api/v1/users/getUsers")
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setUsers(result.users);
        } else {
          setUsers([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setUsers([]);
      });
  };

  const getUserDisplay = (userInfo) => {
    if (
      userInfo == null ||
      userInfo.username == null ||
      userInfo.username === ""
    ) {
      return "-";
    }
    return userInfo.username;
  };

  const showOrders = (id, order) => {
    setModalContent(<ShowRentOrders hasPassOperation={true} id={id} />);
    childRef.current.openModal();
  };
  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw = JSON.stringify({
      filter: {
        fromDate: from != null && from != "" ? from : null,
        toDate: to != null && to != "" ? to : null,
        rentNumber:
          searchParams["rentNumber"].value !== ""
            ? "%" + searchParams["rentNumber"].value + "%"
            : null,
        kiosk: kiosk != null && kiosk != "" ? kiosk.value : null,
        unitId: unit != null && unit != "" ? unit.value : null,
        userId: user != null && user != "" ? user.value : null,
      },
      pl: pagination.pageSize,
      pn: pagination.pageIndex + 1,
      version: "mtpx001",
    });

    var url = "management/api/v1/rents/searchRentsByFilter";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.rents);
          pushData(newList);
          setRents(result.rents);
          setPageCount(result.count);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => setLoading(false));
  };

  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "rentNumber",
        header: "شمازه سفارش",
        align: "center",
      },
      {
        accessorKey: "startDate",
        header: "از تاریخ",
        align: "center",
      },
      {
        accessorKey: "endDate",
        header: "تا تاریخ",
        align: "center",
      },
      {
        accessorKey: "unitName",
        header: "حساب",
        align: "center",
      },
      {
        accessorKey: "userDisplay",
        header: "اکانت",
        align: "center",
      },
      {
        accessorKey: "kioskDescription",
        header: "نام لاکر",
        align: "center",
      },
      {
        accessorKey: "lockerSerials",
        header: "سریال های انتخابی",
        align: "center",
      },
    ];
    const buttons = [];
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        rentNumber: d.rentNumber,
        startDate: d.startDate,
        endDate: d.endDate,
        unitName: !!d.unit ? d.unit.unitName : "-",
        userDisplay: getUserDisplay(d.user),
        kioskDescription: !!d.kiosk ? d.kiosk.description : "",
        lockerSerials: d.lockerSerials,
        subRows: [
          { header: "از ساعت", value: d.startTime },
          { header: "تا ساعت", value: d.endTime },
          {
            header: "هزینه سفارش",
            value: !!d.amount
              ? d.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "-",
          },
        ],
      });
    });
    buttons.push({ id: 1, text: "نمایش سفارش", clicked: showOrders });
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };

  const search = (event) => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };

  const changeFromDate = (unix, formatted) => {
    setFrom(formatted);
  };

  const changeToDate = (unix, formatted) => {
    setTo(formatted);
  };

  const refresh = (event) => {
    setFrom("");
    setTo("");
    setKiosk("");
    setUnit("");
    setUser("");
    loadUsersForUnit(null);
    const srch = searchParams;
    for (let key in srch) {
      srch[key].value = "";
    }
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(searchParams, {
      [controlName]: updateObject(searchParams[controlName], {
        value: event.target.value,
      }),
    });
    setSearchParams(updatedControls);
  };

  const formElementsArray = [];
  for (let key in searchParams) {
    formElementsArray.push({
      id: key,
      config: searchParams[key],
    });
  }

  const afterCloseModal = (event) => {};

  const exportToCSV = (event) => {
    var raw = JSON.stringify({
      filter: {
        fromDate: from != null && from != "" ? from : null,
        toDate: to != null && to != "" ? to : null,
        rentNumber:
          searchParams["rentNumber"].value !== ""
            ? "%" + searchParams["rentNumber"].value + "%"
            : null,
        kiosk: kiosk != null && kiosk != "" ? kiosk.value : null,
        unitId: unit != null && unit != "" ? unit.value : null,
        userId: user != null && user != "" ? user.value : null,
      },
      pl: "1048576",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/rents/searchRentsByFilter";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          let exportRent = [];
          let count = 0;
          const rent = result.rents.map((o) => {
            count++;
            exportRent.push({
              ردیف: count,
              "شماره سفارش": o.rentNumber,
              "تاریخ ثبت": o.registerDate,
              حساب: o.unit != null ? o.unit.unitName : "",
              اکانت: getUserDisplay(o.user),
              "تاریخ شروع": o.startDate,
              "ساعت شروع": o.startTime,
              "تاریخ پایان": o.endDate,
              "ساعت پایان": o.endTime,
              "هزینه نهایی": o.amount,
              "دلیل کنسلی": o.cancelReason,
            });
          });
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(exportRent);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "Rents" + fileExtension);
        }
      })
      .catch((error) => setLoading(false));
  };

  const changeKiosk = (selectedOption) => {
    setKiosk(selectedOption);
  };

  const changeUnit = (selectedOption) => {
    setUnit(selectedOption);
    setUser("");
    loadUsersForUnit(selectedOption);
  };

  const changeUser = (selectedOption) => {
    setUser(selectedOption);
  };
  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="3"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });

  const kioskList = [];
  if (kiosks != null && kiosks.length != 0) {
    kiosks.map((z) => {
      kioskList.push({
        value: z.id,
        label: z.description,
      });
    });
  }

  const unitList = [];
  if (units != null && units.length != 0) {
    units.map((z) => {
      unitList.push({
        value: z.id,
        label: z.unitName,
      });
    });
  }

  const userList = [];
  if (users != null && users.length != 0) {
    users.map((z) => {
      userList.push({
        value: z.username,
        label: z.username,
      });
    });
  }

  form = (
    <div>
      <div className="row pl-4" dir="ltr"></div>
      <div className="row pl-4" dir="ltr">
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row mt-4">
        {form}
        <div className="col-3 full-small">
          <DatePicker
            change={changeFromDate}
            value={from}
            placeHolder="از تاریخ"
          />
        </div>
        <div className="col-3 full-small">
          <DatePicker change={changeToDate} value={to} placeHolder="تا تاریخ" />
        </div>
        <Select
          name="form-field-name"
          value={kiosk}
          placeholder="لاکر"
          options={kioskList}
          onChange={changeKiosk}
          col="3"
        />
        <Select
          name="form-field-name"
          value={unit}
          placeholder="حساب"
          options={unitList}
          onChange={changeUnit}
          col="3"
        />
        <Select
          name="form-field-name"
          value={user}
          placeholder="اکانت"
          options={userList}
          onChange={changeUser}
          col="3"
        />
      </div>
      <div className="row text-left" dir="ltr">
        <div className="col-2 ord-small-btns">
          <Button btnType="search-btn" clicked={search}>
            <span className="tab-color">جستجو</span>
          </Button>
        </div>
        <div className="col-6 text-left ord-small-btns">
          <Button btnType="Search" clicked={exportToCSV}>
            <span className="tab-color">گزارشگیری</span>
          </Button>
        </div>
      </div>
    </div>
  );
  return (
    <div className="third-rents">
      <Search class="rents-search" form={form} />
      <div className="row justify-content-center w-100 ml-0 mr-0">
        {rerender ? (
          // <Spinner />
          <Table
            pageSize={pageSize}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={170}
            loading={loading}
          />
        ) : (
          <Table
            pageSize={pageSize}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={170}
            loading={loading}
          />
        )}
      </div>
      <Modal
        content={modalContent}
        ref={childRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
    </div>
  );
};
export default Rents;
